import { useQuery } from '@tanstack/react-query'
import { fetchLandingPage } from '../api/landingPageApi'

export const useLandingPage = (params = {}, options = {}) => {
    return useQuery({
        queryKey: ['GET_LANDIGN_PAGE'],
        queryFn: async () => {
            const resp = await fetchLandingPage()
            return resp
        },
        ...options
    })
}
